module.exports = __webpack_public_path__ + "static/media/FliterIcon.7ce142db.svg";